import { VisibilityScopeValue } from "../../../components/ui/VisibilityScope";
import { Translation } from "../../../hooks/useTranslations";
import { AdminItem } from "../../types/items";
import { WaterproofKitNoBaseDependency } from "./waterproofKits";

export type BaseTypeValue = "straight" | "right" | "left" | "curved";
export type BaseOrientationValue = "parallel" | "perpendicular";

export type BaseType = {
  value: BaseTypeValue;
  label: string;
};

export type BaseOrientation = {
  value: BaseOrientationValue;
  label: string;
};

export type BaseCorrugationSpan = {
  value: 250 | 333;
  label: string;
};

export const getBaseTypes = (i18n: Translation): BaseType[] => [
  { value: "straight", label: i18n.common.straight },
  { value: "right", label: i18n.common.right },
  { value: "left", label: i18n.common.left },
  { value: "curved", label: i18n.common.curve },
];

export const getBaseOrientations = (i18n: Translation): BaseOrientation[] => [
  { value: "parallel", label: i18n.common.parallel },
  { value: "perpendicular", label: i18n.common.perpendicular },
];

export const getBaseCorrugationSpan: BaseCorrugationSpan[] = [
  { value: 250, label: "250 mm" },
  { value: 333, label: "333 mm" },
];

export const getDistanceOptions = [
  { value: 0, label: "0 mm" },
  { value: 35, label: "35 mm" },
];

export type Base = {
  item: AdminItem;
  order: number;
  visibility: VisibilityScopeValue;
  isVertical: boolean;
  distance: number;
  type: BaseTypeValue;
  isReclinableUpright: boolean;
  baseOrientation?: string;
  corrugationSpan?: number;
  waterproofKit?: WaterproofKitNoBaseDependency;
  width: number;
  height: number;
};

export type BaseNoWaterproofKitDependency = Omit<Base, "waterproofKit"> & {
  waterproofKit?: {
    item: AdminItem;
  };
};

export type UpdateBaseBody = {
  order: number;
  visibility: VisibilityScopeValue;
  isVertical: boolean;
  distance: number;
  type: string;
  isReclinableUpright: boolean;
  baseOrientation?: string;
  corrugationSpan?: number;
  waterproofKitId?: string;
  width: number;
  height: number;
};

export type InsertBaseBody = {
  itemId: string;
  order: number;
  visibility: VisibilityScopeValue;
  isVertical: boolean;
  distance: number;
  type: string;
  isReclinableUpright: boolean;
  baseOrientation?: string;
  corrugationSpan?: number;
  waterproofKitId?: string;
  width: number;
  height: number;
};
